<template>
  <div class="support-menu border-white-1-50 filter-blur-25" v-click-outside="closeOutside">
    <div class="border-yellow-1" v-for="(item, i) in supportOptions" :key="i">
      <div @click="closeMenu">
      <router-link :to="item.url">
        <a>
          <div :class="[lang === 'ar' ? 'flex-row-reverse' : '' ,'item d-flex align-items-center']" >
            <img class="img" :src="require(`../../../src/assets/icons/${item.icon}`)">{{item.title}}
            <img class="yellow-arrow" src="../../../src/assets/icons/yellowArrow.svg">
          </div>
        </a>
      </router-link>
    </div>
    </div>
  </div>
</template>

<script>
import utils from '../../shared/utils'
import $ from 'jquery'
import gc from '../../utils/gc'

export default {
  name: 'SupportMenu',
  data () {
    return {
      supportOptions: [
        {
          title: this.$t('supportMenu.faq'),
          icon: 'FAQ.svg',
          url: '/Support/FAQs'
        },
        {
          title: this.$t('supportMenu.serviceCenter'),
          icon: 'center.svg',
          url: '/Support/Services-Centers'
        },
        {
          title: this.$t('supportMenu.feedback'),
          icon: 'feedback.svg',
          url: '/Support/Feedback'
        },
        {
          title: this.$t('supportMenu.contactUs'),
          icon: 'contact.svg',
          url: '/Support/Contact-Us'
        }
      ],
      base: '../src/assets/icons/',
      reverseDialog: utils.changeDialogStatus,
      lang: this.$lang,
      web: gc.website
    }
  },
  methods: {
    closeOutside () {
      this.$emit('close')
    },
    closeMenu () {
      this.$emit('closeMenu')
    }
  },
  mounted () {
    setTimeout(() => {
      this.$lang === 'ar' ? $('.support-menu').css('left', 'calc(1.5vw + 0.5rem)') && $('.yellow-arrow').css('margin-right', 'auto') && $('.yellow-arrow').css('transform', 'rotate(180deg)') : $('.support-menu').css('right', 'calc(1.5vw + 0.5rem)') && $('.yellow-arrow').css('margin-left', 'auto')
      this.$lang === 'ar' ? $('.support-menu .item').css('font-family', 'Mtn-arabic-bold') : $('.support-menu .item').css('font-family', 'Mtn-bold')
    })
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
.support-menu {
  background: rgba(255, 255, 255, 0.85);
  padding: 0 0.6rem;
  width: 200px;
  border-radius: 15px;
  position: fixed;
  z-index: 200;
  bottom: 9.1rem;
}
.right-float{
  right: calc(1.5vw + 0.5rem);
}
.left-float{
  left: calc(1.5vw + 0.5rem);
}
.yellow-arrow {
  //margin-left: auto;
  width: 7px;
  height: 7px
}
.item {
  color: $--yellow;
  height: 55px;
  font-size: 12px;
  font-family: Mtn-bold;
}
.img {
  margin: 0 0.8rem;
  width: 21px; height: 20px;
}
.border-yellow-1:last-child {
  border-bottom: none!important;
}
.yellow-arrow-container{
  margin-right: auto;
  transform: rotate(180deg);
}
@media screen and (max-width: 575px) {
  .support-menu {
    bottom: 7.3rem;
  }
}
</style>
